import React from 'react';
import { Section } from './ui';
export const Testimonials = () => {
  const testimonials = [{
    id: 1,
    title: '“Pensé que otra vez iba a fallar… y fue el primer pastel que desapareció”',
    text: 'Tengo intolerancia al gluten desde hace 6 años. Probé de todo. Hice una sola receta del Método de Estructura Húmeda™ y no solo quedó húmedo… mi esposo repitió sin saber que era sin gluten.',
    author: 'Carolina M., 42 años | Argentina'
  }, {
    id: 2,
    title: '“Mi hijo es el juez más cruel… y esta vez pidió otro pedazo”',
    text: 'Cuando vi Pasteles Sin Culpa pensé: “seguro sabe feo”. Pero lo compré por el precio. Hice el primer pastel un sábado. Mi hijo lo probó… no dijo nada… y volvió por más.',
    author: 'Laura P., mamá de 2 | Argentina'
  }, {
    id: 3,
    title: '“Lo hice en el primer intento”',
    text: 'No soy buena horneando. Siempre algo sale mal. Por eso me sorprendió que el libro explicara el por qué de cada paso. Seguí el orden tal cual y fue la primera vez que un pastel sin gluten me quedó esponjoso.',
    author: 'Alejandra R., principiante | Argentina'
  }, {
    id: 4,
    title: '“Dejé de sentir vergüenza de llevar postre”',
    text: 'Antes llevaba postres por compromiso. Sabía que nadie iba a comerlos. Ahora me preguntan la receta. Y cuando digo que es sin gluten, no me creen.',
    author: 'María E., celíaca | Argentina'
  }];
  return <Section className="bg-pink-50" data-id="element-215">
      <h2 className="text-2xl sm:text-3xl md:text-4xl font-serif font-semibold text-center mb-10 leading-tight" data-id="element-216">
        Más de 500 personas ya hornean sin miedo
      </h2>

      <div className="grid md:grid-cols-2 gap-5 md:gap-6 max-w-5xl mx-auto" data-id="element-217">
        {testimonials.map(t => <div key={t.id} className="bg-white p-6 md:p-8 rounded-2xl shadow-soft border border-pink-100 flex flex-col" data-id="element-218">
            <div className="flex text-yellow-400 mb-3 text-lg md:text-xl" data-id="element-219">
              ★★★★★
            </div>
            <h4 className="text-lg md:text-xl font-bold font-serif mb-3 text-brand-dark leading-snug" data-id="element-220">
              {t.title}
            </h4>
            <p className="text-base text-gray-600 mb-5 flex-grow italic" data-id="element-221">
              {t.text}
            </p>
            <p className="font-bold text-xs sm:text-sm text-gray-500 uppercase tracking-wide" data-id="element-222">
              {t.author}
            </p>
          </div>)}
      </div>
    </Section>;
};